module.exports = __webpack_public_path__ + "img/list.e3a09fab.png";